const APP_HOST = "app.vestd.com";
const COMPANY_ID = /^[1-9]\d{0,11}$/;

export const isCompanyId = (value: unknown): value is string => typeof value === "string" && COMPANY_ID.test(value);

// The numeric company ID from an app.vestd.com company URL, or undefined for anything else. Only this ID ever reaches the AI.
export function parseCompanyUrl(input: string): { companyId: string } | undefined {
  let url: URL;
  try {
    url = new URL(input.trim());
  } catch {
    return undefined;
  }
  if (url.protocol !== "https:" || url.hostname !== APP_HOST || url.port || url.username || url.password) {
    return undefined;
  }
  const [empty, section, companyId] = url.pathname.split("/");
  if (empty !== "" || section !== "company" || !companyId || !COMPANY_ID.test(companyId)) {
    return undefined;
  }
  return { companyId };
}
